import { Injectable } from "@angular/core";
import { CardModel } from "src/app/shared/models/card.model";
import { Faq } from "src/app/shared/models/faq.model";
import { SwiperOptions } from "swiper";

@Injectable({
  providedIn: "root",
})
export class CaixaTemService {
  private readonly cards: CardModel[] = [
    {
      img: "card4.png",
      title: "Link de pagamento",
      text: "",
    },
    {
      img: "qr.png",
      title: "QR Code",
      text: "",
    },
    {
      img: "card2.png",
      title: "Gestão facilitada",
      text: "",
    },
    {
      img: "card9.png",
      title: "Suporte 100% digital",
      text: "",
    },
    {
      img: "icone-nfc.svg",
      title: "Pagamentos por aproximação",
      text: "via App azulzinha aproxima",
    },
  ];

  private readonly cardsCelHabilita: CardModel[] = [
    {
      img: "phone-cx-tem-1.png",
      text: 'Na tela inicial do App CAIXA Tem, toque em "azulzinha". <br> <strong>Importante:</strong> você precisa ter uma Conta Digital MEI para visualizar esta opção no menu "Produtos e Serviços".',
    },
    {
      img: "phone-cx-tem-2.png",
      text: 'Em seguida, você verá uma tela que explica os benefícios da azulzinha para o dia a dia do seu negócio. Toque em "próximo".',
    },
    {
      img: "phone-cx-tem-3.png",
      text: 'Na tela de escolha do seu plano de uso, você verá o "Plano Flex" sem mensalidade. Toque em "Aceitar plano" para prosseguir. E tocando em "ver mais detalhes" você visualiza suas taxas.',
    },
    {
      img: "phone-cx-tem-4.png",
      text: 'Clique em "Continuar" para prosseguir com a revisão dos seus dados cadastrais e a leitura dos termos e condições de uso da azulzinha.',
    },
    {
      img: "phone-cx-tem-5.png",
      text: "Verifique seus dados e corrija, se necessário. Antes de confirmar, leia e aceite os Termos e Condições. ",
    },
    {
      img: "phone-cx-tem-6.png",
      text: 'Na tela de resumo, confira sua proposta, leia o Contrato de serviços e clique em "Confirmar". Agora é só aguardar a liberação da sua azulzinha!',
    },
  ];

  private readonly cardsCelIndetifica: CardModel[] = [
    {
      img: "passo-01.png",
      text: "Selecione a azulzinha no menu “Serviços e Produtos” e clique em “Continuar”.",
    },
    {
      img: "passo-02.png",
      text: "Digite o número do celular usado no seu cadastro e seu CPF para receber um SMS com o link de acesso, que é válido por 24 horas.",
    },
    {
      img: "passo-03.png",
      text: "Clique no link de acesso e realize a confirmação da sua identificação. Basta conferir as indicações na tela e clicar em “Começar”.",
    },
    {
      img: "passo-04.png",
      text: "Na tela de permissão do acesso, confira os termos de uso, marque a opção de aceite e clique em permitir.",
    },
    {
      img: "passo-05.png",
      text: "Tire uma foto do seu documento – CNH ou RG – e siga as orientações. Será preciso enviar a foto da frente e do verso do documento. ",
    },
    {
      img: "passo-06.png",
      text: "Para concluir, tire e envie uma foto nítida do seu rosto e aguarde até 48 horas. Após a aprovação, você já poderá receber com a azulzinha!",
    },
  ];

  private readonly faqArray: Faq[] = [
    {
      ask: "O que é a azulzinha no App CAIXA Tem?",
      res: `
      Além de facilitar o acesso a serviços bancários e sociais, o aplicativo CAIXA Tem oferece recursos que facilitam o dia a dia de quem é Microempreendedor Individual (MEI).
      <p class='mt-4'>Ao habilitar a azulzinha da CAIXA no seu App CAIXA Tem, você pode:</p>
      <ul class='ul-faq'>
        <li>Receber pagamentos via link de pagamento ou QR Code, direto no App CAIXA Tem;</li>
        <li>Transformar o celular em uma maquininha, usando o App azulzinha aproxima, para aceitar pagamentos por aproximação.</li>
      </ul>
      `,
    },
    {
      ask: "Sou MEI. Como faço para receber pagamentos com a azulzinha?",
      res: `
     <p>Para ativar os pagamentos com a azulzinha, o primeiro passo é criar uma Conta Corrente Digital MEI. Para isso, acesse o site da CAIXA <a target='_blank' href="https://www.caixa.gov.br/empresa/contas/conta-corrente-mei/Paginas/default.aspx">clicando aqui</a> e preencha seus dados. É importante que você tenha em mãos os seguintes documentos:</p>
      <ul class='ul-faq'>
      <li>CNPJ;</li>
      <li>Certificado da Condição do Microempreendedor Individual (CCMEI).</li>
      </ul>

      <p>Se você já tem uma Conta Corrente MEI da CAIXA, siga as orientações da próxima pergunta ou <a href="/azulzinha-caixa-tem/Agora tem azulzinha no App CAIXA Tem!">assista aqui</a>  ao tutorial de habilitação da azulzinha no App CAIXA Tem. </p>
      
     `,
    },
    {
      ask: "Como habilitar a azulzinha no CAIXA Tem?",
      res: `<p>Se você já criou uma conta digital MEI da CAIXA, depois que ela for aprovada, você pode habilitar a azulzinha para receber pagamentos pelo CAIXA Tem direto na sua conta digital MEI.</p> 
       
      <p><a href="/azulzinha-caixa-tem/Agora tem azulzinha no App CAIXA Tem!">Assista aqui</a> ao tutorial de habilitação ou siga o passo passo e veja como é fácil:</p>

      <ul class='ul-faq'>
        <li>Na tela inicial do App CAIXA Tem, selecione “azulzinha”;</li>
        <li>Na etapa seguinte, veja os benefícios da azulzinha para o dia a dia do seu negócio e clique em “próximo”;</li>
        <li>Você verá o plano de uso da azulzinha – “Plano Flex” sem mensalidade. Clique em “Aceitar plano” para seguir (ou em “ver mais detalhes” para conferir as taxas);</li>
        <li>Clique em “Continuar” para ir à tela seguinte, revisar seus dados cadastrais e corrigir, se necessário;</li>
        <li>Leia e aceite os termos e condições para ser direcionado à tela de resumo, onde você poderá conferir a proposta e o Contrato de serviços. Toque na caixa de seleção para concordar com os termos e depois clique em “Confirmar”.</li>
      </ul>
      <p>Depois de receber a liberação da azulzinha no seu CAIXA Tem, é hora de realizar o primeiro acesso e começar a receber pagamentos com a azulzinha.</p>
      
      `,
    },
    {
      ask: "O que preciso fazer no meu primeiro acesso?",
      res: `
      <p>Antes de você começar a receber pagamentos, você precisará habilitar a azulzinha seguindo os passos abaixo:</p>
      <ul class='ul-faq'>
        <li>Selecione a azulzinha no menu “Serviços e Produtos”, clique em
   “Continuar” e siga os passos seguintes;</li>
        <li>Digite o número do celular usado no seu cadastro e seu CPF para receber um SMS com o link de acesso, que é válido por 24 horas;</li>
        <li>Clique no link de acesso e realize a confirmação da sua identificação (basta conferir as indicações na tela e clicar em “Continuar”);</li>
        <li>Na tela seguinte, confira os termos, marque a opção de aceite e clique em permitir;</li>
        <li>Tire uma foto do seu documento – CNH ou RG – e siga as orientações para o envio da imagem. Será preciso enviar a foto da frente e do verso do documento;</li>
        <li>Em seguida, faça uma foto nítida do seu rosto de acordo com as indicações na tela e clique em “Sim, enviar foto”;</li>
      </ul>
      <p>Pronto, agora é só aguardar a análise dos documentos, que leva até 48 horas. Após a aprovação, você já pode começar a receber com a azulzinha no CAIXA Tem.</p>
      `,
    },
    {
      ask: "Preciso de suporte, como faço?",
      res: `
      <p>O suporte da azulzinha é 100% digital. <a href="/azulzinha-caixa-tem/Como tirar suas dúvidas no App CAIXA Tem?">Assista aqui às orientações</a> sobre o acesso ao suporte ou siga o passo a passo:</p>

      <p>No App CAIXA Tem, selecione o menu azulzinha e clique no ícone de atendimento para acessar o chat e tirar suas dúvidas de forma facilitada e rápida, já que o menu apresenta diversas opções organizadas por tipo de assunto.</p>
      
      `,
    },
    {
      ask: "Como faço para vender com a azulzinha?",
      res: `
      <p>Você pode realizar vendas usando QR Code ou Link de Pagamento. Basta acessar seu aplicativo CAIXA Tem, clicar em azulzinha no menu, depois em "Nova Venda" e escolher a melhor opção de pagamento para atender o seu cliente. </p>

      <p>Se precisar de ajuda para gerar seu primeiro Link de Pagamento ou QR Code, <a href="/azulzinha-caixa-tem#videos">assista aqui aos vídeos</a> com o passo a passo. </p>
      `,
    },
    {
      ask: "Não consigo visualizar a opção de link de pagamento. O que preciso fazer?",
      res: "<p>A tecnologia Link de Pagamento está liberada apenas para alguns ramos de atividade. Para obter mais informações sobre a liberação para o seu estabelecimento, acesse o nosso atendimento digital no menu azulzinha do aplicativo CAIXA Tem.</p>",
    },
    {
      ask: "Não achei a opção de pagamento por aproximação. Como faço?",
      res: `
      <p>Para transformar o seu celular em maquininha, você precisa fazer o download do App azulzinha aproxima. Antes de acessar a Google Play Store, certifique-se de que o seu celular utilize sistema operacional Android versão 9 ou superior, tenha tecnologia NFC (ou antena NFC) e esteja conectado a alguma rede de Wi-Fi ou 5G, 4G e 3G. </p>
      
      <p>Baixe o aplicativo e siga o passo a passo:</p>
      <ul class='ul-faq'>
        <li>Ao abrir o App azulzinha aproxima pela primeira vez, selecione “Ative a sua conta”;</li>
        <li>Depois digite o seu CNPJ e clique em confirmar;</li>
        <li>Na sequência, leia os termos, dê o aceite em cada um e finalize clicando em “De acordo”. Esse procedimento será feito apenas uma vez.</li>
      </ul>

      <p>Se preferir, assista ao tutorial em vídeo <a href="/azulzinha-caixa-tem/Como fazer uma venda por aproximação no App CAIXA Tem?">clicando aqui</a>.</p>
      `,
    },
    {
      ask: "Já baixei o App azulzinha aproxima. Como faço para vender?",
      res: 'Para saber mais sobre as funcionalidades, benefícios e fazer suas vendas por aproximação, <a href="/azulzinha-caixa-tem/Como fazer uma venda por aproximação no App CAIXA Tem?">clique aqui</a>.',
    },
    {
      ask: "Posso consultar minhas vendas e pagamentos no App CAIXA Tem?",
      res: `
      <p>
        Sim. Para consultar suas vendas, clique em azulzinha no menu, depois em "Ver Vendas".
        Para ter acesso aos pagamentos realizados, clique em "Ver Recebimentos".
      </p>

      <p>Se preferir, <a href="/azulzinha-caixa-tem/Como consultar seus recebimentos no App CAIXA Tem?">assista aqui ao tutorial</a> em vídeo. </p>
    
      `,
    },
    {
      ask: "Quais são as taxas aplicadas?",
      res: 'Consulte as taxas direto no App CAIXA Tem clicando em azulzinha no menu, depois na opção "Taxas e Tarifas”, onde você poderá ver as taxas por bandeira e tipo de transação. Se preferir, <a href="/azulzinha-caixa-tem/Como consultar as taxas e tarifas da função azulzinha?">assista aqui ao vídeo</a> com o passo a passo.  ',
    },
    {
      ask: "Como criar um link de pagamento?",
      res: `
      
      <p>Siga o passo a passo para criar seu primeiro link de pagamento no App CAIXA Tem com a azulzinha:</p>
      <ul class='ul-faq'>
        <li>Abra o App CAIXA Tem e clique no menu azulzinha;</li>
        <li>Vá até a opção Nova Venda;</li>
        <li>Selecione Link de Pagamento;</li>
        <li>Se for seu primeiro acesso, leia e aceite os termos de condições;</li>
        <li>Crie uma descrição para facilitar a identificação da venda (opcional);</li>
        <li>Insira o valor do produto ou serviço;</li>
        <li>Escolha a forma de pagamento: à vista ou parcelado (com ou sem juros);</li>
        <li>Na tela final, revise todos os passos anteriores;</li>
        <li>Se precisar corrigir algo, clique no ícone de lápis ao lado da informação para editar;</li>
        <li>Quando estiver tudo correto, clique em Gerar link de pagamento.</li>

      </ul>
        <p>Pronto! Agora é só encaminhar o link gerado para seu cliente via redes sociais ou aplicativos de mensagens.</p>
      <p>Se preferir, assista ao tutorial em vídeo sobre link de pagamentos <a href="azulzinha-caixa-tem/Como gerar um Link de Pagamento no App CAIXA Tem?">clicando aqui</a>. </p>`,
    },
    {
      ask: "O que é o QR Code e como usá-lo?",
      res: '<p>O QR Code permite que o seu cliente pague rapidamente por um produto ou serviço escaneando o código com o celular. No aplicativo CAIXA Tem, depois de clicar em “azulzinha” no menu, você pode gerar um QR Code para compartilhar com o cliente e realizar uma venda.</p> <p>Se preferir <a href="/azulzinha-caixa-tem/Como fazer uma venda com QR Code no App CAIXA Tem?">assista aqui ao vídeo tutorial</a> sobre como fazer uma venda com QR Code no App CAIXA Tem.</p>',
    },
    {
      ask: "Como consultar minhas vendas realizadas?",
      res: 'Saiba como consultar seus recebimentos com a azulzinha no App CAIXA Tem no tutorial em vídeo. <a href="/azulzinha-caixa-tem/Como consultar seus recebimentos no App CAIXA Tem?">Clique aqui para assistir</a>.',
    },
    {
      ask: "Contratei a azulzinha no aplicativo CAIXA Tem e quero uma maquininha. Como solicito?",
      res: "As vendas na azulzinha via aplicativo CAIXA Tem podem ser feitas somente através do QR Code, link de pagamento e azulzinha aproxima.",
    },
    {
      ask: "Quais bandeiras de cartões são aceitas pela azulzinha?",
      res: "A azulzinha aceita as principais bandeiras, vouchers e carteiras digitais favoritas do seu cliente. Consulte todas as bandeiras disponíveis diretamente no aplicativo CAIXA Tem.",
    },
    {
      ask: "Como posso saber mais sobre produtos como empréstimos ou capital de giro?",
      res: "Além das vendas, o App CAIXA Tem oferece informações sobre outros produtos, como empréstimos e capital de giro. Para saber mais, acesse o menu da azulzinha e consulte as opções disponíveis.",
    },
  ];

  constructor() {}

  public getCards(): CardModel[] {
    return this.cards;
  }

  public getCardsCelHabilita(): CardModel[] {
    return this.cardsCelHabilita;
  }

  public getCardsCelIndentifica(): CardModel[] {
    return this.cardsCelIndetifica;
  }

  public getFaqArray(): Faq[] {
    return this.faqArray;
  }
}
